export default __webpack_public_path__ + "static/media/alex0.dca01852.jpg";